export default __webpack_public_path__ + "static/media/image-hipercard.2a281465.svg";